import BaseRepository from '@/api/repositories/BaseRepository';

export default class DamageCaseNoteRepository extends BaseRepository {
	showNote(noteId) {
		return this.get(`damagecases-notes/${noteId}`, {});
	}

	storeNote(data) {
		return this.post('damagecases-notes', {}, data);
	}

	updateNote(noteId, data) {
		return this.put(`damagecases-notes/${noteId}`, {}, data);
	}
}
